export interface PaywallContext {
  paywallCheck: string;
}

export const defaultPaywallContext: PaywallContext = {
  paywallCheck: 'pending',
};
